(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('RoomType', RoomType);

    RoomType.$inject = ['$resource'];

    function RoomType ($resource) {
        var resourceUrl =  'api/room-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
